// Constants for muscle groups
export const MUSCLE_GROUPS = [
  {
    id: 'chest',
    name: 'Pecho',
    icon: 'fitness',
  },
  {
    id: 'back',
    name: 'Espalda',
    icon: 'body',
  },
  {
    id: 'legs',
    name: 'Piernas',
    icon: 'walk',
  },
  {
    id: 'shoulders',
    name: 'Hombros',
    icon: 'barbell',
  },
  {
    id: 'arms',
    name: 'Brazos',
    icon: 'arm',
  },
  {
    id: 'abs',
    name: 'Abdominales',
    icon: 'fitness',
  },
  {
    id: 'glutes',
    name: 'Glúteos',
    icon: 'body',
  },
  {
    id: 'calves',
    name: 'Pantorrillas',
    icon: 'walk',
  },
  {
    id: 'cardio',
    name: 'Cardio',
    icon: 'heart',
  },
  {
    id: 'full_body',
    name: 'Cuerpo completo',
    icon: 'body',
  },
];

// Specific sub-muscle groups
export const SUB_MUSCLE_GROUPS = {
  chest: [
    { id: 'upper_chest', name: 'Pecho superior' },
    { id: 'mid_chest', name: 'Pecho medio' },
    { id: 'lower_chest', name: 'Pecho inferior' }
  ],
  back: [
    { id: 'lats', name: 'Dorsales' },
    { id: 'traps', name: 'Trapecios' },
    { id: 'rhomboids', name: 'Romboides' },
    { id: 'lower_back', name: 'Lumbar' }
  ],
  legs: [
    { id: 'quads', name: 'Cuádriceps' },
    { id: 'hamstrings', name: 'Isquiotibiales' },
    { id: 'adductors', name: 'Aductores' },
    { id: 'abductors', name: 'Abductores' }
  ],
  shoulders: [
    { id: 'front_delts', name: 'Deltoides anterior' },
    { id: 'side_delts', name: 'Deltoides lateral' },
    { id: 'rear_delts', name: 'Deltoides posterior' }
  ],
  arms: [
    { id: 'biceps', name: 'Bíceps' },
    { id: 'triceps', name: 'Tríceps' },
    { id: 'forearms', name: 'Antebrazos' }
  ],
  abs: [
    { id: 'upper_abs', name: 'Abdominales superiores' },
    { id: 'lower_abs', name: 'Abdominales inferiores' },
    { id: 'obliques', name: 'Oblicuos' }
  ],
  glutes: [
    { id: 'gluteus_maximus', name: 'Glúteo mayor' },
    { id: 'gluteus_medius', name: 'Glúteo medio' }
  ],
  calves: [
    { id: 'gastrocnemius', name: 'Gemelos' },
    { id: 'soleus', name: 'Sóleo' }
  ]
}; 